import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Scheduler/constants";
export const initSchedulerModuleAction = createAction(`${moduleSlug}/initSchedulerModuleAction`);